import React, { useEffect, useState } from 'react';
import { Button, Card, CardBody, CardHeader, Col, Container, Input, InputGroup, Row, InputGroupText } from 'reactstrap';
import BreadcrumbTrail from '../../../../../../Common/BreadcrumbTrail';
import { useHistory } from 'react-router-dom';
import { CustomCard } from '../Comman';
import { useDispatch, useSelector } from 'react-redux';
import { GET_CLIENT_DETAILS_V2, GET_CLIENT_V2 } from '../../../../../../../store/actions';
import cogoToast from 'cogo-toast';

const SelectClient = ({ state, setState, setFormCount }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [selectedClient, setSelectedClient] = useState(null);
  const [client, setClient] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredClients, setFilteredClients] = useState([]);

  const { getClient, getClientDetails } = useSelector((state: any) => ({
    getClient: state.GetClientV2.data?.results?.clients,
    getClientDetails: state.GetClientDetailsV2.data?.results,
  }));

  useEffect(() => {
    if (state?.client) {
      setSelectedClient(state?.client);
    }

    dispatch({
      type: GET_CLIENT_V2,
      payload: {
        urlParams: {
          page_size: 100,
          page_index: 1,
        },
      },
    });
  }, [state]);

  useEffect(() => {
    if (getClientDetails !== null && selectedClient) {
      setState(prev => ({ ...prev, client: { ...selectedClient, carTypes: getClientDetails?.car_types ?? [] } }));
      setSelectedClient(prev => ({ ...prev, carTypes: getClientDetails?.car_types ?? [] }));
      setFormCount((prev: number) => prev + 1);
    }
  }, [getClientDetails]);

  useEffect(() => {
    if (getClient?.length) {
      setFilteredClients(getClient); // Initially show all clients
    }
  }, [getClient]);

  const filterClient = (term: string) => {
    setSearchTerm(term);
    if (!term.trim()) {
      setFilteredClients(getClient);
    } else {
      const lowerTerm = term.toLowerCase();
      const filtered = getClient.filter(
        client => client?.name?.toLowerCase().includes(lowerTerm) || client?.contracting_country?.name?.toLowerCase().includes(lowerTerm),
      );
      setFilteredClients(filtered);
    }
  };

  const breadcrumNavigationHandler = title => {
    if (title === `Dashboard`) {
      history.push(`/dashboard`);
    }
  };

  const handleSubmit = () => {
    if (!selectedClient) {
      cogoToast.error('Please select client first');
      return;
    }
    setState(prev => ({ ...prev, client: selectedClient }));
    setFormCount((prev: number) => prev + 1);
  };

  return (
    <div className="page-content">
      <Container fluid className="position-relative">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex gap-1 align-items-center">
            <BreadcrumbTrail
              title={`Program Onboarding`}
              navigationby={breadcrumNavigationHandler}
              navigation={['Management', 'Program', 'Onboarding', 'Client List']}
            />
          </div>

          <div>
            <Input
              style={{ width: '250px', paddingLeft: '30px' }}
              placeholder="Search Client"
              value={searchTerm}
              onChange={e => filterClient(e.target.value)}
            />
            <i className="ri-search-line fs-16" style={{ position: 'absolute', top: '26px', right: '236px' }}></i>
          </div>
        </div>

        <Card>
          <CardHeader>
            <h5 className="m-0 fw-semibold">Select Client</h5>
          </CardHeader>
          <CardBody className="pb-5">
            <Row className="d-flex mx-1 mt-2" style={{ height: '340px', overflowY: 'scroll' }}>
              {filteredClients?.map((client: any, index: number) => {
                const isSelected = selectedClient?.id === client.id;
                return (
                  <CustomCard
                    clientName={client.name}
                    country={client?.contracting_country?.name}
                    key={index}
                    selected={isSelected}
                    onClick={() => {
                      if (selectedClient?.id === client.id) {
                        cogoToast.info('Client already selected');
                        return;
                      }
                      setSelectedClient(prev => (prev?.id === client.id ? null : client));
                      dispatch({
                        type: GET_CLIENT_DETAILS_V2,
                        payload: {
                          urlParams: {
                            clientId: client?.id,
                          },
                        },
                      });
                    }}
                  />
                );
              })}
              {filteredClients?.length === 0 && <div className="text-center text-muted mt-3">No clients found</div>}
            </Row>
          </CardBody>
        </Card>

        <div className="d-flex justify-content-end">
          <Button className="overlay-disable" style={{ width: '130px' }} color="primary" onClick={handleSubmit}>
            Continue
          </Button>
        </div>
      </Container>
    </div>
  );
};

export default SelectClient;
